import React from 'react';

import './ContentPage.css';
import { Box, Typography } from '@mui/material';
import { AccordionData } from '../AccordionData';
import { ButtonBack } from '../ButtonBack';

export function ContentPage() {
  return (
    <Box className="contentPage">
      <Typography
        className="headerContent"
        variant="h4"
        component="h1"
      >
        Perguntas frequentes
      </Typography>

      <AccordionData />

      <ButtonBack />
    </Box>
  );
}
